import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { take, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { SessionService } from 'src/app/store/session/session.service';

@Injectable({
  providedIn: 'root'
})
export class HasSessionGuard implements CanActivate {

  constructor(
    private router: Router,
    private sessionService: SessionService
  ) { }

  canActivate() {
    return this.sessionService.isAuthenticated().pipe(
      take(1),
      switchMap(isLoggedIn => {
        if (isLoggedIn) {
          this.router.navigateByUrl('/');
          return of(false);
        }
        return of(true);
      })
    );
  }
}
